export enum ScreenNamesEnum {
  appointment_list = 'appointment_list',
  appointment_view = 'appointment_view',
  card_payments_onboarding = 'card_payments_onboarding',
  client_list = 'client_list',
  client_view = 'client_view',
  credit_memo_create = 'credit_memo_create',
  credit_memo_list = 'credit_memo_list',
  credit_memo_send = 'credit_memo_send',
  credit_memo_view = 'credit_memo_view',
  estimate_create = 'estimate_create',
  estimate_list = 'estimate_list',
  estimate_send = 'estimate_send',
  estimate_view = 'estimate_view',
  expense_view = 'expense_view',
  help = 'help',
  home = 'home',
  invoice_create = 'invoice_create',
  invoice_list = 'invoice_list',
  invoice_record_transaction = 'invoice_record_transaction',
  invoice_send = 'invoice_send',
  invoice_view = 'invoice_view',
  item_view = 'item_view',
  job_view = 'job_view',
  paypal_onboarding = 'paypal_onboarding',
  paywall = 'paywall',
  purchase = 'purchase',
  purchase_order_create = 'purchase_order_create',
  purchase_order_list = 'purchase_order_list',
  purchase_order_send = 'purchase_order_send',
  purchase_order_view = 'purchase_order_view',
  reports = 'reports',
  settings = 'settings',
  tracked_time_list = 'tracked_time_list',
  tracked_time_view = 'tracked_time_view',
  unmatched_payments = 'unmatched_payments',
  update_tax_year = 'update_tax_year',
}
